import $ from 'jquery';
import 'jquery-ui/ui/widgets/autocomplete';

export default class Search {
	constructor() {
		this.autocompleteMock = [
			'kaspersky',
			'безопасные платежи в Kaspersky Security Cloud 19',
			'обновить антивирусные базы из локальной папки',
			'родительский контроль в Kaspersky Internet Security 2018',
			'список программ несовместимых с Kaspersky Total Security'
		];
		this.searchInput = $('.search__input');
		this.field = $('.search__field');
	}

	init() {
		this.searchInput.autocomplete({
			appendTo: this.field,
			source: this.autocompleteMock,
			minLength: 3
		});
	}
}



// WEBPACK FOOTER //
// ./app/blocks/search/index.js